var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-content",attrs:{"id":"sign-content"}},[_c('canvas',{ref:"signHandle",staticClass:"canvas",attrs:{"id":"canvas"},on:{"touchstart":_vm.drawStart,"touchmove":_vm.drawing,"touchend":_vm.drawEnd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }